<template>
    <section
        class="row-banner"
        :class="{ 'row-banner--error': containErrorPlaceHolder }"
    >
        <BaseLink
            :href="url"
            :title="`Sprawdź naszą oferte na - ${url}`"
            class="row-banner__image-wrapper"
        >
            <ProgressiveImage
                v-for="image in imagesWithClass"
                :key="image.type"
                :data="{ src: image.src, alt: `row banner ${image.type}`}"
                :class="[ ...image.classNames, 'row-banner__image' ]"
                @error="containErrorPlaceHolder = true"
            />
        </BaseLink>
    </section>
</template>

<script>
import BaseLink from '~/components/common/Link/BaseLink';
import ProgressiveImage from '~/components/common/Image/ProgressiveImage';

export default {
    name: 'RowBanner',
    components: { ProgressiveImage, BaseLink },
    props: {
        url: {
            type: String,
            required: true,
        },
        images: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            types: [
                'desktop',
                'tablet',
                'mobile',
            ],
            containErrorPlaceHolder: false,
        };
    },
    computed: {
        imagesWithClass() {
            return this.images.map((image) => {
                const { type: currentImageType } = image;
                const inactiveTypes = this.types.filter(type => type !== currentImageType);
                return {
                    ...image,
                    classNames: inactiveTypes.map(type => `${type}-hide`),
                };
            });
        },
    },
};
</script>

<style lang="scss">
    .row-banner {
        width: 100%;
        height: 96px;
        display: block;
        text-align: center;
        position: relative;

        &--error {
            width: 100%;

            .row-banner__image-wrapper{
                text-align: center;
                background: $color-castoWhite;

                .row-banner__image {
                    max-height: 100%;
                    display: inline-block;
                }
            }
        }

        &::after {
            display: inline-block;
            width: 1144px;
            height: 100%;
            border: solid 4px $color-castoWhite;
            background: $color-slate5;
            overflow: hidden;
            box-sizing: border-box;
            content: '';
            left: 0;
            top: 0;
            position: absolute;
            z-index: 1;
        }

        &__wrapper {
            width: 100%;
            height: 100%;
        }

        &__image-wrapper, iframe {
            display: inline-block;
            width: 1144px;
            height: 100%;
            border: solid 4px $color-castoWhite !important;
            background: $color-slate5;
            overflow: hidden;
            box-sizing: border-box;
            z-index: 2;
            position: relative;
        }

        .double-click, .double-click > div {
            width: 1144px;
            height: 100%;
        }

        &__image {
            max-width: 100%;
        }
    }

    @media (min-width: $mf-breakpoint-big-desktop) {
        .row-banner {
            width: 100%;
            max-width: 1144px;
            margin: 0;
        }
    }

    @media (min-width: $mf-breakpoint-small-desktop) and (max-width: $mf-breakpoint-big-desktop) {
        .row-banner {
            height: 79px;

            &::after {
                width: 930px;
                left: 8px;
                max-width: 720px;
            }

            &__image-wrapper, iframe, .double-click, .double-click > div {
                width: 930px;
            }
        }
    }

    @media (min-width: $mf-breakpoint-tablet) and (max-width: $mf-breakpoint-small-desktop) {
        .row-banner {
            &::after {
                width: 720px;
                left: 16px;
            }

            &__image-wrapper, iframe, .double-click, .double-click > div {
                width: 720px;
            }
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .row-banner {
            height: 75vw;

            &::after {
                content: none;
            }

            &__image-wrapper, iframe, .double-click, .double-click > div {
                width: 100%;
            }
        }
    }
</style>
